import { FormattedMessage } from 'react-intl';

type Props = {
  readonly type: 'LENGTH' | 'CHARS';
};
const InvalidDocumentNumber = ({ type }: Props): JSX.Element => {
  if (type === 'CHARS') {
    return (
      <FormattedMessage
        id="account_v2.components.form_errors.invalid_document_number.chars"
        defaultMessage="Must be digits or characters"
      />
    );
  }
  return (
    <FormattedMessage
      id="account_v2.components.form_errors.invalid_document_number.length"
      defaultMessage="Must be between 5 and 20 characters"
    />
  );
};

export default InvalidDocumentNumber;
